<template>
  <UISelectButtonField
    :id="id"
    v-model="model"
    :label="t('label')"
    :options="phoneTypes"
    :option-value="'value'"
  />
</template>

<script setup lang="ts">
  import { computed, toRef, watch } from "vue"
  import UISelectButtonField from "@ui-kit/components/select-button"
  import { useI18n } from "vue-i18n"

  interface Props {
    id: string
  }

  const props = defineProps<Props>()
  const id = toRef(props, "id")

  export type PhoneType = "mobilePhone" | "homePhone"

  const { t } = useI18n()

  const model = defineModel<PhoneType>()

  const phoneTypes = computed(() => {
    return [
      {
        label: t("phoneType.home"),
        value: "homePhone",
      },
      {
        label: t("phoneType.mobile"),
        value: "mobilePhone",
      },
    ]
  })

  watch(model, (newValue) => {
    if (!newValue) {
      model.value = "homePhone"
    }
  })
</script>

<i18n lang="yaml" locale="en">
label: Phone Type

phoneType:
  home: Home
  mobile: Mobile
</i18n>
